import Vue from 'vue'
import App from './App.vue'
import * as firebase from 'firebase'
import './registerServiceWorker.js'
import router from './router'
import config from './config'
import alertify from 'alertifyjs'
import './../node_modules/alertifyjs/build/css/alertify.min.css'
import Vuex from 'vuex'
import VueCarousel from 'vue-carousel'

Vue.use(VueCarousel)
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    story: {
      title: 'null'
    },
    progress: {
      episode: 1,
      chapter: 1,
      number_of_stories: 0,
      welcome: true,
      finished: false,
      episode_interval: 60,
      email_notify: true,
      debug: false,
      fades: []
    }
  },
  mutations: {
    titleUpdate (state, title) {
      state.story.title = title
    }
  }
})
Vue.config.productionTip = false

// Initialize Firebase
firebase.initializeApp(config.firebaseConfig)
const requireComponent = require.context(
  // Look for files in the current directory
  './components',
  // Do not look in subdirectories
  false,
  // Only include "_base-" prefixed .vue files
  /_base-[\w-]+\.vue$/
)
// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireComponent(fileName)
  // Get the PascalCase version of the component name
  const componentName = fileName
    // Remove the "./_base" from the beginning
    .replace(/^\.\/_base/, '')
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')
    // Split up kebabs
    .split('-')
    // Upper case
    .map((kebab) => kebab.charAt(0).toUpperCase() + kebab.slice(1))
    // Concatenated
    .join('')
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})
Object.defineProperty(Vue.prototype, '$alertify', { value: alertify })
new Vue({
  data: {
    hello: 'hello',
    config: {
      predefinedPassword: config.predefinedPassword,
      locations: config.locations,
      episodes: config.episodes,
      initialProgress: config.initialProgress
    }
  },
  router,
  render: h => h(App),
  methods: {

  },
  store: store
}).$mount('#app')
